"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const mediaQueries_1 = require("../../styles/mediaQueries");
/**
 * Template represents a layout for content on main pages of the survey.
 * On mobile devices there is only content block.
 * On desktop devices you'll see also an image in the left column.
 *
 * @param image - displaying image in the left column
 * @param content - content of the page in the right column
 * @param alternate - if true, image and content will be displayed in reverse order
 * @constructor
 */
function PageContent({ Image, content, alternate, className, }) {
    return ((0, jsx_runtime_1.jsxs)(PageContentContainer, { alternate: alternate, className: className, "data-e2e": 'PageContent_PageContentContainer', children: [(0, jsx_runtime_1.jsx)(Image, { "data-e2e": 'PageContent_Image' }), (0, jsx_runtime_1.jsx)(ContentContainer, { "data-e2e": 'PageContent_ContentContainer', children: content })] }));
}
exports.PageContent = PageContent;
const PageContentContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;

  // Don't show image on mobile devices
  & > svg {
    display: none;
  }

  ${({ alternate }) => mediaQueries_1.device.desktop `
    flex-direction: ${alternate ? 'row-reverse' : 'row'};
    
    justify-content: center;
    
    gap: 40px;

    // Show image only on desktop devices
    & > svg {
      display: block;
      
      width: 100%;
      height: 100%;

      // Fix for fill color in SVG
      color: #000;
      
      z-index: 1;
    }
  `}
`;
const ContentContainer = styled_components_1.default.div `
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-direction: column;

  box-sizing: border-box;

  ${mediaQueries_1.device.desktop `
    height: 100%;
    width: 376px;
    
    align-items: flex-start;
    padding: 40px 0px 16px 16px;
  `};
`;
